import React, { useContext, useState, useRef, useEffect } from 'react';
import { ProductContext } from './ProductContext';
import './LanguageSwitcher.css';

const languages = [
  { code: 'en', label: 'English', flag: '/images/Flags/En.png' },
  { code: 'es', label: 'Español', flag: '/images/Flags/Es.png' },
  { code: 'pt', label: 'Português', flag: '/images/Flags/Pt.png' },
  { code: 'fr', label: 'Français', flag: '/images/Flags/Fr.png' }
];

const LanguageSwitcher = () => {
  const { selectedLanguage, setSelectedLanguage } = useContext(ProductContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLanguageChange = (langCode) => {
    setSelectedLanguage(langCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const currentLang = languages.find(lang => lang.code === selectedLanguage);

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <div className={`dropdown ${isOpen ? 'open' : ''}`}>
        <button className="dropdown-btn" onClick={() => setIsOpen(!isOpen)}>
          <img src={currentLang.flag} alt="Flag" style={{ width: '20px', marginRight: '10px' }} />
          {currentLang.label}
        </button>
        {isOpen && (
          <div className="dropdown-content">
            {languages.map((lang) => (
              <div key={lang.code} className="dropdown-item" onClick={() => handleLanguageChange(lang.code)}>
                <img src={lang.flag} alt={lang.label} style={{ width: '20px', marginRight: '10px' }} />
                {lang.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
